import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={135.2}
      height={128.863}
      viewBox="0 0 135.2 128.863"
      {...props}
    >
      <g data-name="Group 40">
        <path
          data-name="Path 59"
          d="M124.638 67.601a57.038 57.038 0 11-57.037-57.037 57.026 57.026 0 0157.037 57.037z"
          fill="#ffd200"
          opacity={0.5}
        />
      </g>
      <g data-name="Group 41">
        <path
          data-name="Path 60"
          d="M117.243 67.6A49.644 49.644 0 1167.6 17.957 49.649 49.649 0 01117.243 67.6z"
          fill="#ffd200"
          opacity={0.4}
        />
      </g>
      <g data-name="Group 42">
        <path
          data-name="Path 61"
          d="M109.85 67.602A42.25 42.25 0 1167.6 25.353a42.258 42.258 0 0142.25 42.249z"
          fill="#ffce54"
          opacity={0.6}
        />
      </g>
      <path
        data-name="Path 62"
        d="M85.556 119.357l-4.225 4.225H53.869l-4.225-4.225v-14.788h35.912z"
        fill="#003586"
      />
      <g data-name="Group 43">
        <path
          data-name="Path 63"
          d="M53.869 104.569h-4.23v14.788l4.225 4.225h4.225l-4.225-4.225z"
          fill="#fff"
          opacity={0.4}
        />
      </g>
      <g data-name="Group 44">
        <path
          data-name="Path 64"
          d="M81.331 104.569h4.222v14.788l-4.225 4.225h-4.225l4.225-4.225z"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 65"
        d="M102.457 67.6a34.856 34.856 0 10-52.813 29.835v7.134h35.912v-7.134A34.8 34.8 0 00102.457 67.6z"
        fill="#e6e9ed"
      />
      <g data-name="Group 45" fill="#fff">
        <path
          data-name="Path 66"
          d="M67.6 32.744c.714 0 1.413.059 2.115.106A34.83 34.83 0 0036.969 67.6a41.883 41.883 0 0012.675 29.835A34.83 34.83 0 0167.6 32.744z"
        />
        <path
          data-name="Path 67"
          d="M67.602 32.744c-.714 0-1.413.059-2.115.106A34.83 34.83 0 0198.233 67.6a41.882 41.882 0 01-12.675 29.835 34.83 34.83 0 00-17.956-64.691z"
        />
      </g>
      <path
        data-name="Path 68"
        d="M58.094 123.581s2.113 4.225 9.506 4.225 9.506-4.225 9.506-4.225z"
        fill="#656d78"
      />
      <g data-name="Group 46">
        <path
          data-name="Path 69"
          d="M62.319 123.581h-4.225s2.113 4.225 9.506 4.225a16.686 16.686 0 002.113-.136c-5.682-.701-7.394-4.089-7.394-4.089z"
          fill="#fff"
          opacity={0.4}
        />
      </g>
      <g data-name="Group 47">
        <path
          data-name="Path 70"
          d="M72.882 123.581h4.225s-2.113 4.225-9.506 4.225a16.682 16.682 0 01-2.113-.136c5.681-.701 7.394-4.089 7.394-4.089z"
          opacity={0.3}
        />
      </g>
      <path
        data-name="Path 71"
        d="M49.639 104.568l17.956-17.956 17.956 17.956z"
        fill="#965353"
      />
      <g data-name="Group 48">
        <path
          data-name="Path 72"
          d="M67.6 86.612l-15.845 15.844h4.225l13.731-13.732z"
          fill="#fff"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 49">
        <path
          data-name="Path 73"
          d="M69.712 88.725l13.731 13.732H79.22L67.604 90.842z"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 50">
        <path
          data-name="Rectangle 31"
          d="M49.643 102.457h35.912v2.112H49.643z"
          opacity={0.2}
        />
      </g>
      <path
        data-name="Path 74"
        d="M72.65 59.507a8.058 8.058 0 0010.633 12.11c3.342-2.938 8.693-15.151 7.34-17.168s-14.625 2.124-17.973 5.058z"
        fill="#a0d468"
      />
      <g data-name="Group 51">
        <path
          data-name="Path 75"
          d="M90.623 54.449c-.346-.518-1.485-.625-3.037-.456a1.365 1.365 0 01.924.456c1.353 2.018-4 14.231-7.34 17.168a8.037 8.037 0 01-4.18 1.912 8.011 8.011 0 006.292-1.912c3.343-2.938 8.692-15.151 7.341-17.168z"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 52">
        <path
          data-name="Path 76"
          d="M74.024 70.878a8.058 8.058 0 01.738-11.371c2.49-2.18 10.453-5.022 14.936-5.514-3.366-.614-14.086 2.919-17.048 5.514a8.05 8.05 0 006.453 14.022 7.984 7.984 0 01-5.079-2.651z"
          fill="#fff"
          opacity={0.5}
        />
      </g>
      <path
        data-name="Path 77"
        d="M54.657 75.293a5.282 5.282 0 006.1-8.625c-2.381-1.686-12.159-5.052-12.923-3.291s4.442 10.23 6.823 11.916z"
        fill="#a0d468"
      />
      <g data-name="Group 53">
        <path
          data-name="Path 78"
          d="M60.755 66.668c-2.13-1.508-10.161-4.35-12.381-3.673a32.914 32.914 0 0110.269 3.673 5.269 5.269 0 01-2.013 9.479 5.279 5.279 0 004.126-9.479z"
          opacity={0.2}
        />
      </g>
      <g data-name="Group 54">
        <path
          data-name="Path 79"
          d="M56.769 75.293c-2.381-1.686-7.588-10.154-6.824-11.916a.794.794 0 01.542-.383c-1.392-.205-2.427-.141-2.654.383-.763 1.762 4.444 10.23 6.824 11.916a5.255 5.255 0 004.085.854 5.249 5.249 0 01-1.973-.854z"
          fill="#fff"
          opacity={0.5}
        />
      </g>
      <g data-name="Group 55" fill="#3a3847">
        <path
          data-name="Path 80"
          d="M67.663 95.063a1.065 1.065 0 01-1.067-1.056 1.047 1.047 0 011.046-1.056h.021a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 81"
          d="M64.495 98.232a1.065 1.065 0 01-1.067-1.056 1.047 1.047 0 011.046-1.056h.021a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 82"
          d="M61.326 101.401a1.065 1.065 0 01-1.067-1.056 1.047 1.047 0 011.046-1.056h.021a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 83"
          d="M67.663 101.401a1.065 1.065 0 01-1.067-1.056 1.047 1.047 0 011.046-1.056h.021a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 84"
          d="M73.999 101.401a1.064 1.064 0 01-1.064-1.056 1.046 1.046 0 011.044-1.056H74a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 85"
          d="M70.831 98.232a1.064 1.064 0 01-1.064-1.056 1.046 1.046 0 011.044-1.056h.021a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 86"
          d="M81.331 124.638H53.869a1.055 1.055 0 01-.747-.309l-4.225-4.225a1.055 1.055 0 01-.309-.747v-14.788a1.055 1.055 0 011.056-1.056h35.912a1.055 1.055 0 011.056 1.056v14.788a1.057 1.057 0 01-.309.747l-4.225 4.225a1.058 1.058 0 01-.747.309zm-27.025-2.112h26.588l3.606-3.606v-13.294H50.7v13.29z"
        />
        <path
          data-name="Path 87"
          d="M47.53 111.963a1.057 1.057 0 01-.055-2.112l40.137-2.113a1.058 1.058 0 01.112 2.113l-40.137 2.112z"
        />
        <path
          data-name="Path 88"
          d="M47.53 118.304a1.057 1.057 0 01-.055-2.112l40.137-2.112a1.058 1.058 0 11.112 2.112l-40.137 2.112z"
        />
        <path
          data-name="Path 89"
          d="M85.556 105.625H49.648a1.056 1.056 0 01-1.056-1.056v-6.548a35.913 35.913 0 1138.025 0v6.548a1.055 1.055 0 01-1.061 1.056zM50.7 103.513h33.8v-6.082a1.051 1.051 0 01.512-.9 33.8 33.8 0 10-34.822 0 1.052 1.052 0 01.511.9v6.082z"
        />
        <path
          data-name="Path 90"
          d="M67.601 128.865c-7.955 0-10.353-4.613-10.451-4.809a1.057 1.057 0 011.886-.953c.083.159 2 3.649 8.566 3.649s8.487-3.5 8.566-3.652a1.057 1.057 0 011.886.955c-.106.195-2.499 4.81-10.453 4.81z"
        />
        <path
          data-name="Path 91"
          d="M22.185 68.657H1.056a1.056 1.056 0 110-2.112h21.129a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 92"
          d="M134.144 68.657h-21.126a1.056 1.056 0 110-2.112h21.125a1.056 1.056 0 110 2.112z"
        />
        <path
          data-name="Path 93"
          d="M9.969 101.931a1.057 1.057 0 01-.529-1.972l18.3-10.562a1.057 1.057 0 011.056 1.832l-18.3 10.562a1.059 1.059 0 01-.527.14z"
        />
        <path
          data-name="Path 94"
          d="M106.937 45.943a1.056 1.056 0 01-.528-1.971l18.29-10.562a1.056 1.056 0 111.056 1.83l-18.29 10.563a1.05 1.05 0 01-.528.14z"
        />
        <path
          data-name="Path 95"
          d="M90.314 29.324a1.047 1.047 0 01-.528-.141 1.058 1.058 0 01-.388-1.443L99.956 9.445a1.057 1.057 0 011.832 1.056L91.23 28.796a1.063 1.063 0 01-.916.528z"
        />
        <path
          data-name="Path 96"
          d="M67.604 23.233a1.056 1.056 0 01-1.056-1.056V1.056a1.056 1.056 0 112.112 0v21.121a1.056 1.056 0 01-1.056 1.056z"
        />
        <path
          data-name="Path 97"
          d="M44.896 29.32a1.055 1.055 0 01-.916-.528L33.417 10.501a1.056 1.056 0 111.83-1.056l10.562 18.291a1.056 1.056 0 01-.914 1.584z"
        />
        <path
          data-name="Path 98"
          d="M125.231 101.924a1.055 1.055 0 01-.528-.14l-18.295-10.562a1.057 1.057 0 111.056-1.832l18.296 10.557a1.056 1.056 0 01-.528 1.972z"
        />
        <path
          data-name="Path 99"
          d="M28.27 45.939a1.051 1.051 0 01-.527-.141L9.448 35.239a1.056 1.056 0 111.056-1.83l18.295 10.558a1.056 1.056 0 01-.529 1.971z"
        />
        <path
          data-name="Path 100"
          d="M53.869 101.4a1.056 1.056 0 01-.747-1.8l13.731-13.734a1.056 1.056 0 011.493 1.494l-13.733 13.731a1.054 1.054 0 01-.744.309z"
        />
        <path
          data-name="Path 101"
          d="M81.331 101.4a1.053 1.053 0 01-.747-.31L66.853 87.359a1.056 1.056 0 011.493-1.493l13.732 13.731a1.056 1.056 0 01-.747 1.8z"
        />
        <path
          data-name="Path 102"
          d="M77.969 74.625a9.112 9.112 0 01-6.016-15.962c2.876-2.517 12.481-5.855 16.85-5.855 1.366 0 2.249.329 2.7 1 1.857 2.767-4.225 15.65-7.522 18.546a9.11 9.11 0 01-6.012 2.271zm10.834-19.7c-3.854 0-12.953 3.139-15.456 5.331a7.008 7.008 0 00-.641 9.88 7.2 7.2 0 009.88.642c3.321-2.919 7.8-14.1 7.159-15.778a6.749 6.749 0 00-.942-.075z"
        />
        <path
          data-name="Path 103"
          d="M67.6 84.501a1.056 1.056 0 01-1.056-1.056c0-13.166 12.91-20.015 13.459-20.3a1.056 1.056 0 01.974 1.874c-.124.065-12.32 6.56-12.32 18.427a1.056 1.056 0 01-1.057 1.055z"
        />
        <path
          data-name="Path 104"
          d="M57.701 77.272a6.292 6.292 0 01-3.654-1.164c-2.222-1.572-8.347-10.514-7.184-13.2.326-.752 1.117-1.133 2.353-1.133 3.237 0 10.134 2.554 12.15 3.98a6.339 6.339 0 01-3.665 11.514zm-8.913-13.354c.075 1.707 4.278 8.91 6.475 10.465a4.334 4.334 0 005.888-1.011 4.224 4.224 0 00-1.01-5.89c-1.765-1.249-8.177-3.593-10.93-3.593a2.733 2.733 0 00-.423.029z"
        />
        <path
          data-name="Path 105"
          d="M65.489 80.275a1.058 1.058 0 01-.892-.489 31.182 31.182 0 00-10.168-10.2 1.057 1.057 0 01.994-1.865A32.9 32.9 0 0166.38 78.648a1.056 1.056 0 01-.89 1.624z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
